import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ENUMS } from '../../../../utils/constants';
import { translate, isNullOrEmpty, showMessageToastCustom } from '../../../../utils/util';
import * as actionsPicking from '../../../../actions/pickingAction';
import PickingService from '../../../../services/PickingService';
import { Button, ScannerCode, Breadcrumbs } from '../../../../components/UI/ComponentsUI';
import { getUser } from '../../../../services/auth';

const AutomaticFinalization = (props) => {
    const inputFilter = useRef();
    const [orderItemCode, setOrderItemCode] = useState('');
    const [refreshed, setRefreshed] = useState(false);
    const [filtering, setFiltering] = useState(false);

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    };

    useEffect(() => {
        props.clearPicking();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        inputFilter.current.focus();
    }, [inputFilter]);

    useEffect(() => {
        if (filtering) {
            if (props.orders?.items?.length > 0) {
                let order = props.orders.items[0];
                let mission = order.items.find(i => i.orderItemCode === props.filter.orderItemCode);
                if (order.status === ENUMS.eOrderStatus.Waiting.value || (order.status === ENUMS.eOrderStatus.InProgress.value && order.startedBy !== getUser().userName)) {
                    props.startOrder(order.orderId, () => {
                        props.setSelectedOrder(order);
                        props.startOrderItem(order.orderId, mission.orderItemId, () => {
                            props.setSelectedMission(mission);
                            submit()
                        });
                    });
                } else {
                    props.startOrderItem(order.orderId, mission.orderItemId, () => {
                        props.setSelectedMission(mission);
                        submit()
                    });
                }
            }
            else if (props.filter.orderItemCode !== undefined) {
                showMessageToastCustom(translate('general:warning'), translate('general:no-registry'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
        // eslint-disable-next-line
    }, [props.orders]);

    const applyFilter = () => {
        if (!isNullOrEmpty(orderItemCode)) {
            props.filter.orderItemCode = orderItemCode;
            props.filter.orderType = ENUMS.eOrderType.Picking.value;
            props.setFilterOrderItem(props.filter);
            props.getOrders(props.filter, {
                PageIndex: 0
            }, () => setFiltering(true));
            refreshComponent();
        }
    };

    const scannerBarCode = (value) => {
        setOrderItemCode(value);
    };

    const submit = () => {
        props.confirmPicking(props.mission, () => {
            showMessageToastCustom(translate('confirmed', 'general'), translate('expedition:picking.finalization-success'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            inputFilter.current.value = null;
            inputFilter.current.focus();
            props.updateMissionStatus(props.mission.orderItemId, ENUMS.eOrderItemStatus.Finished.value);
            props.resetFilter();
            setOrderItemCode('')
        });
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrderItem" title={{ icon: "mdi mdi-calendar-multiple-check", label: translate('expedition:picking.automatic-finalization') }} />
            <div className="container" style={{ marginTop: '60px', }}>
                <div className="row">
                    <div className="input-field no-padding col s12">
                        <ScannerCode onScanner={scannerBarCode} />
                        <input
                            autoFocus
                            id="inputFilter"
                            name="inputFilter"
                            ref={inputFilter}
                            placeholder={translate('expedition:picking.filterByTask')}
                            type="number"
                            onChange={(event) => { setOrderItemCode(event.currentTarget.value); }}
                            maxLength="20"
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <Button full="true" onClick={() => applyFilter()} text={translate('confirm', 'general')} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pickingReducer.filter,
        orders: state.pickingReducer.orders,
        mission: state.pickingReducer.mission
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrderItem: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        },
        setSelectedOrder: (order) => {
            dispatch(actionsPicking.selectOrder(order));
        },
        resetFilter: (filter) => {
            dispatch(actionsPicking.resetFilter(filter));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(PickingService.getOrders(filter, pagination, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionsPicking.selectMission(mission));
        },
        confirmPicking: (orderItem, callback) => {
            dispatch(PickingService.confirmPicking(orderItem, callback));
        },
        updateMissionStatus: (orderItemId, status) => {
            dispatch(actionsPicking.updateMissionStatus(orderItemId, status));
        },
        startOrder: (orderId, callback) => {
            dispatch(PickingService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(PickingService.startOrderItem(orderId, orderItemId, callback));
        },
        clearPicking: () => {
            dispatch(actionsPicking.resetFilter());
            dispatch(actionsPicking.resetOrders());
            dispatch(actionsPicking.resetOrder());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AutomaticFinalization)));